var _clipPath, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgS1Gas9Button(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 515.7322834645669 641.9238845144357",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l515.7323 0l0 641.9239l-515.7323 0l0 -641.9239z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l515.7323 0l0 641.9239l-515.7323 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m31.364271 172.23799l0 0c0 -41.66136 33.77321 -75.43457 75.43458 -75.43457l301.72925 0l0 0c20.0065 0 39.193573 7.947548 53.3403 22.094276c14.1467285 14.146721 22.0943 33.33381 22.0943 53.340294l0 381.94977c0 41.661377 -33.773224 75.43457 -75.4346 75.43457l-301.72925 0c-41.66137 0 -75.43458 -33.773193 -75.43458 -75.43457z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m31.364271 172.23799l0 0c0 -41.66136 33.77321 -75.43457 75.43458 -75.43457l301.72925 0l0 0c20.0065 0 39.193573 7.947548 53.3403 22.094276c14.1467285 14.146721 22.0943 33.33381 22.0943 53.340294l0 381.94977c0 41.661377 -33.773224 75.43457 -75.4346 75.43457l-301.72925 0c-41.66137 0 -75.43458 -33.773193 -75.43458 -75.43457z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m126.43569 42.13145l0 0c0 -6.041912 4.8979416 -10.93985 10.9398575 -10.93985l51.726593 0c2.9014282 0 5.684021 1.1525879 7.7356415 3.2042084c2.0516205 2.0516205 3.2042084 4.8342133 3.2042084 7.7356415l0 43.75809c0 6.041916 -4.897934 10.9398575 -10.93985 10.9398575l-51.726593 0c-6.041916 0 -10.9398575 -4.8979416 -10.9398575 -10.9398575z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m126.43569 42.13145l0 0c0 -6.041912 4.8979416 -10.93985 10.9398575 -10.93985l51.726593 0c2.9014282 0 5.684021 1.1525879 7.7356415 3.2042084c2.0516205 2.0516205 3.2042084 4.8342133 3.2042084 7.7356415l0 43.75809c0 6.041916 -4.897934 10.9398575 -10.93985 10.9398575l-51.726593 0c-6.041916 0 -10.9398575 -4.8979416 -10.9398575 -10.9398575z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m9.068241 417.4735l0 0c0 -3.487732 2.827361 -6.315094 6.3150873 -6.315094l484.56668 0c1.6748657 0 3.281128 0.66534424 4.4654236 1.8496704c1.1843262 1.1842957 1.8496704 2.7905579 1.8496704 4.4654236l0 25.259583c0 3.487732 -2.827362 6.315094 -6.315094 6.315094l-484.56668 0c-3.4877262 0 -6.3150873 -2.827362 -6.3150873 -6.315094z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m9.068241 417.4735l0 0c0 -3.487732 2.827361 -6.315094 6.3150873 -6.315094l484.56668 0c1.6748657 0 3.281128 0.66534424 4.4654236 1.8496704c1.1843262 1.1842957 1.8496704 2.7905579 1.8496704 4.4654236l0 25.259583c0 3.487732 -2.827362 6.315094 -6.315094 6.315094l-484.56668 0c-3.4877262 0 -6.3150873 -2.827362 -6.3150873 -6.315094z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m312.0 42.13145l0 0c0 -6.041912 4.897949 -10.93985 10.93985 -10.93985l51.726593 0c2.9014282 0 5.684021 1.1525879 7.7356567 3.2042084c2.0516052 2.0516205 3.204193 4.8342133 3.204193 7.7356415l0 43.75809c0 6.041916 -4.8979187 10.9398575 -10.93985 10.9398575l-51.726593 0c-6.0419006 0 -10.93985 -4.8979416 -10.93985 -10.9398575z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 16,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m312.0 42.13145l0 0c0 -6.041912 4.897949 -10.93985 10.93985 -10.93985l51.726593 0c2.9014282 0 5.684021 1.1525879 7.7356567 3.2042084c2.0516052 2.0516205 3.204193 4.8342133 3.204193 7.7356415l0 43.75809c0 6.041916 -4.8979187 10.9398575 -10.93985 10.9398575l-51.726593 0c-6.0419006 0 -10.93985 -4.8979416 -10.93985 -10.9398575z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m68.95276 184.6293l0 0c0 -19.154953 15.528152 -34.683105 34.683105 -34.683105l308.46054 0c9.198547 0 18.020325 3.6540985 24.524689 10.158447c6.5043335 6.5043488 10.158447 15.326126 10.158447 24.524658l0 138.72827c0 19.154938 -15.528168 34.683105 -34.683136 34.683105l-308.46054 0c-19.154953 0 -34.683105 -15.528168 -34.683105 -34.683105z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 12,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m68.95276 184.6293l0 0c0 -19.154953 15.528152 -34.683105 34.683105 -34.683105l308.46054 0c9.198547 0 18.020325 3.6540985 24.524689 10.158447c6.5043335 6.5043488 10.158447 15.326126 10.158447 24.524658l0 138.72827c0 19.154938 -15.528168 34.683105 -34.683136 34.683105l-308.46054 0c-19.154953 0 -34.683105 -15.528168 -34.683105 -34.683105z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m306.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m306.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m322.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m322.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m338.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m338.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m354.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m354.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m370.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m370.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m386.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m386.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m402.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m402.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m418.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m418.31497 313.18896l0 16.251984",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m126.43569 64.0105l73.6063 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m126.43569 64.0105l73.6063 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m312.0 64.0105l73.60629 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m312.0 64.0105l73.60629 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m303.0 297.14697l108.0 0.85040283",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    strokeDasharray: "4.0,12.0",
    d: "m303.0 297.14697l108.0 0.85040283",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m310.5013 152.0l0 108.0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m310.5013 152.0l0 108.0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m185.45145 255.94751l0 0c0 -20.32582 16.477325 -36.803146 36.803146 -36.803146l0 0c9.760803 0 19.121826 3.8774567 26.023758 10.779388c6.901932 6.901932 10.779388 16.262955 10.779388 26.023758l0 0c0 20.325806 -16.477325 36.80316 -36.803146 36.80316l0 0c-20.32582 0 -36.803146 -16.477356 -36.803146 -36.80316z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m185.45145 255.94751l0 0c0 -20.32582 16.477325 -36.803146 36.803146 -36.803146l0 0c9.760803 0 19.121826 3.8774567 26.023758 10.779388c6.901932 6.901932 10.779388 16.262955 10.779388 26.023758l0 0c0 20.325806 -16.477325 36.80316 -36.803146 36.80316l0 0c-20.32582 0 -36.803146 -16.477356 -36.803146 -36.80316z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m102.614174 185.5304l0 0c0 -6.0419006 4.897934 -10.93985 10.93985 -10.93985l167.50613 0c2.9014282 0 5.684021 1.1525879 7.7356567 3.2042084c2.0516052 2.0516205 3.204193 4.8342133 3.204193 7.7356415l0 43.758102c0 6.041916 -4.897949 10.93985 -10.93985 10.93985l-167.50613 0c-6.041916 0 -10.93985 -4.897934 -10.93985 -10.93985z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m102.614174 185.5304l0 0c0 -6.0419006 4.897934 -10.93985 10.93985 -10.93985l167.50613 0c2.9014282 0 5.684021 1.1525879 7.7356567 3.2042084c2.0516052 2.0516205 3.204193 4.8342133 3.204193 7.7356415l0 43.758102c0 6.041916 -4.897949 10.93985 -10.93985 10.93985l-167.50613 0c-6.041916 0 -10.93985 -4.897934 -10.93985 -10.93985z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m207.80052 262.00787l0 0c0 -3.3050232 2.679245 -5.984253 5.984253 -5.984253l0 0c1.5871277 0 3.1092377 0.63049316 4.2315063 1.7527466c1.1222687 1.1222534 1.7527466 2.6443787 1.7527466 4.2315063l0 0c0 3.3050232 -2.679245 5.984253 -5.984253 5.984253l0 0c-3.305008 0 -5.984253 -2.6792297 -5.984253 -5.984253z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m207.80052 262.00787l0 0c0 -3.3050232 2.679245 -5.984253 5.984253 -5.984253l0 0c1.5871277 0 3.1092377 0.63049316 4.2315063 1.7527466c1.1222687 1.1222534 1.7527466 2.6443787 1.7527466 4.2315063l0 0c0 3.3050232 -2.679245 5.984253 -5.984253 5.984253l0 0c-3.305008 0 -5.984253 -2.6792297 -5.984253 -5.984253z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m227.26804 262.00787l0 0c0 -3.3050232 2.679245 -5.984253 5.984253 -5.984253l0 0c1.5871277 0 3.1092377 0.63049316 4.2315063 1.7527466c1.1222687 1.1222534 1.7527466 2.6443787 1.7527466 4.2315063l0 0c0 3.3050232 -2.679245 5.984253 -5.984253 5.984253l0 0c-3.305008 0 -5.984253 -2.6792297 -5.984253 -5.984253z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m227.26804 262.00787l0 0c0 -3.3050232 2.679245 -5.984253 5.984253 -5.984253l0 0c1.5871277 0 3.1092377 0.63049316 4.2315063 1.7527466c1.1222687 1.1222534 1.7527466 2.6443787 1.7527466 4.2315063l0 0c0 3.3050232 -2.679245 5.984253 -5.984253 5.984253l0 0c-3.305008 0 -5.984253 -2.6792297 -5.984253 -5.984253z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m310.50656 250.27165l136.28348 0l0 18.67717l-136.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m310.50656 250.27165l136.28348 0l0 18.67717l-136.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m329.00262 176.23865l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371338 0 0.8564148 0.17367554 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m329.00262 176.23865l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371338 0 0.8564148 0.17367554 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m329.00262 192.36372l0 0c0 -0.9103546 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371338 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.30911255 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483154 -1.6483154 1.6483154l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483154z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m329.00262 192.36372l0 0c0 -0.9103546 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371338 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.30911255 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483154 -1.6483154 1.6483154l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483154z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m329.00262 208.49095l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371338 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.73799133 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m329.00262 208.49095l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371338 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.73799133 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m329.00262 224.61601l0 0c0 -0.91033936 0.7379761 -1.6483154 1.6483154 -1.6483154l13.648254 0c0.4371338 0 0.8564148 0.17366028 1.1655273 0.48277283c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m329.00262 224.61601l0 0c0 -0.91033936 0.7379761 -1.6483154 1.6483154 -1.6483154l13.648254 0c0.4371338 0 0.8564148 0.17366028 1.1655273 0.48277283c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m353.9841 176.23865l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17367554 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m353.9841 176.23865l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17367554 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m353.9841 192.36372l0 0c0 -0.9103546 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.30911255 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483154 -1.6483154 1.6483154l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483154z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m353.9841 192.36372l0 0c0 -0.9103546 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.30911255 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483154 -1.6483154 1.6483154l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483154z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m353.9841 208.49095l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.73799133 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m353.9841 208.49095l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.73799133 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m353.9841 224.61601l0 0c0 -0.91033936 0.7379761 -1.6483154 1.6483154 -1.6483154l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.48277283c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m353.9841 224.61601l0 0c0 -0.91033936 0.7379761 -1.6483154 1.6483154 -1.6483154l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.48277283c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m378.96558 176.23865l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17367554 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m378.96558 176.23865l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17367554 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m378.96558 192.36372l0 0c0 -0.9103546 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.30911255 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483154 -1.6483154 1.6483154l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483154z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m378.96558 192.36372l0 0c0 -0.9103546 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.30911255 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483154 -1.6483154 1.6483154l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483154z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m378.96558 208.49095l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.73799133 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m378.96558 208.49095l0 0c0 -0.91033936 0.7379761 -1.6483307 1.6483154 -1.6483307l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.4827881c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.91033936 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.73799133 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m378.96558 224.61601l0 0c0 -0.91033936 0.7379761 -1.6483154 1.6483154 -1.6483154l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.48277283c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m378.96558 224.61601l0 0c0 -0.91033936 0.7379761 -1.6483154 1.6483154 -1.6483154l13.648254 0c0.4371643 0 0.8564148 0.17366028 1.1655273 0.48277283c0.30911255 0.3091278 0.4827881 0.7283783 0.4827881 1.1655426l0 6.593109c0 0.9103546 -0.7379761 1.6483307 -1.6483154 1.6483307l-13.648254 0c-0.91033936 0 -1.6483154 -0.7379761 -1.6483154 -1.6483307z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m54.97113 297.9449l0 0c0 -10.462982 8.481911 -18.944885 18.944878 -18.944885l0 0c5.024498 0 9.843201 1.9959717 13.396057 5.548828c3.5528564 3.5528564 5.548828 8.3715515 5.548828 13.396057l0 0c0 10.462952 -8.481911 18.944885 -18.944885 18.944885l0 0c-10.462967 0 -18.944878 -8.481934 -18.944878 -18.944885z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m54.97113 297.9449l0 0c0 -10.462982 8.481911 -18.944885 18.944878 -18.944885l0 0c5.024498 0 9.843201 1.9959717 13.396057 5.548828c3.5528564 3.5528564 5.548828 8.3715515 5.548828 13.396057l0 0c0 10.462952 -8.481911 18.944885 -18.944885 18.944885l0 0c-10.462967 0 -18.944878 -8.481934 -18.944878 -18.944885z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m422.81104 213.91339l0 0c0 -10.462982 8.481903 -18.944885 18.944885 -18.944885l0 0c5.024475 0 9.84317 1.9959717 13.396027 5.548828c3.5528564 3.5528564 5.548828 8.3715515 5.548828 13.396057l0 0c0 10.462967 -8.481903 18.94487 -18.944855 18.94487l0 0c-10.462982 0 -18.944885 -8.481903 -18.944885 -18.94487z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0d6b46",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m422.81104 213.91339l0 0c0 -10.462982 8.481903 -18.944885 18.944885 -18.944885l0 0c5.024475 0 9.84317 1.9959717 13.396027 5.548828c3.5528564 3.5528564 5.548828 8.3715515 5.548828 13.396057l0 0c0 10.462967 -8.481903 18.94487 -18.944855 18.94487l0 0c-10.462982 0 -18.944885 -8.481903 -18.944885 -18.94487z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6d727",
    d: "m345.43832 267.90027l42.0 -42.0l42.0 42.0l-21.0 0l0 116.519684l-42.0 0l0 -116.519684z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m345.43832 267.90027l42.0 -42.0l42.0 42.0l-21.0 0l0 116.519684l-42.0 0l0 -116.519684z",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1Gas9Button);
export default __webpack_public_path__ + "static/media/s1-gas-9-button.bc57b3325b9d191234b5211aa58ec96d.svg";
export { ForwardRef as ReactComponent };